import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";  //newely added

function ClientAdminProtected({ access, children }) {
  const token = localStorage.getItem("isAdmin");
  // return token === "true" ? (
  const userInfo = useSelector((state) => state.user);//newely added
  // Check if user is impersonated - allow access for impersonated users even if not admin
  const isImpersonated = userInfo?.data?.impersonate_acc === true;
  // Allow access if user is admin OR if user is impersonated (even if not admin)
  const hasAccess = token === "true" || isImpersonated;
  return hasAccess ? (
    access === false ? (
      <Navigate to="/home" />
    ) : (
      children
    )
  ) : (
    <Navigate to="/home" />
  );
}

export default ClientAdminProtected;
